import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';

import {
  BarberAddProduct,
  ShopAddProduct,
  BrandAddProduct,
  BarberEditProduct,
  ShopEditProduct,
  BrandEditProduct,
} from './ProductForm';
import { requireProductsAddPermission, requireProductsModifyPermission } from '../../auth/routerHooks';
import { ShopProductList, BarberProductList, BrandProductList } from './ProductList';

export const ShopProductListRoutes = store => (
  <Route>
    <IndexRoute component={ShopProductList} />
    <Route path="add" component={ShopAddProduct} onEnter={requireProductsModifyPermission(store)} />
    <Route path=":id/edit" component={ShopEditProduct} onEnter={requireProductsModifyPermission(store)} />
  </Route>
);

export const BarberProductListRoutes = store => (
  <Route>
    <IndexRoute component={BarberProductList} />
    <Route path="add" component={BarberAddProduct} onEnter={requireProductsAddPermission(store)} />
    <Route path=":id/edit" component={BarberEditProduct} onEnter={requireProductsModifyPermission(store)} />
  </Route>
);

export const BrandProductListRoutes = store => (
  <Route>
    <IndexRoute component={BrandProductList} />
    <Route path="add" component={BrandAddProduct} onEnter={requireProductsModifyPermission(store)} />
    <Route path=":id/edit" component={BrandEditProduct} onEnter={requireProductsModifyPermission(store)} />
  </Route>
);
